import { TechnologyType } from '@@types/api.types';
import { Checkbox } from '@components/ui/checkbox';
import { FormErrorMessage, FormField, FormLabel } from '@components/ui/form/shared.component';
import { cn } from '@lib/utils';

export const CYBER_ASSESSMENT_TECHNOLOGY_TYPE_OPTIONS = [
  {
    description: 'Assess software-specific secure development, deployment, and runtime controls.',
    label: 'Software',
    value: TechnologyType.SOFTWARE,
  },
  {
    description: 'Assess mixed hardware and software control coverage together.',
    label: 'Hybrid',
    value: TechnologyType.HYBRID,
  },
  {
    description: 'Assess hardware supply-chain, platform, and device security controls.',
    label: 'Hardware',
    value: TechnologyType.HARDWARE,
  },
] as const;

type TechnologyCreateCyberAssessmentTypesFieldProps = {
  onCheckedChange: (params: { checked: boolean; technologyType: TechnologyType }) => void;
  selectedTechnologyTypes: TechnologyType[];
};

export function TechnologyCreateCyberAssessmentTypesField(props: TechnologyCreateCyberAssessmentTypesFieldProps) {
  const { onCheckedChange, selectedTechnologyTypes } = props;

  return (
    <FormField>
      <FormLabel required>Assessment Types</FormLabel>
      <div className="space-y-2">
        {CYBER_ASSESSMENT_TECHNOLOGY_TYPE_OPTIONS.map((option) => {
          const checkboxId = `technology-type-${option.value}`;
          const isSelected = selectedTechnologyTypes.includes(option.value);

          return (
            <label
              className={cn(
                'flex cursor-pointer items-start gap-3 rounded-lg border p-3 transition-colors',
                isSelected ? 'border-[#3D2EFF66] bg-[#3D2EFF0F]' : 'border-gray-200 hover:bg-gray-50',
              )}
              htmlFor={checkboxId}
              key={option.value}
            >
              <Checkbox
                checked={isSelected}
                className="mt-0.5 size-5"
                id={checkboxId}
                onCheckedChange={(checked) => {
                  onCheckedChange({
                    checked: checked === true,
                    technologyType: option.value,
                  });
                }}
              />
              <div className="flex-1">
                <div className="font-medium text-gray-900">{option.label}</div>
                <div className="text-sm text-gray-500">{option.description}</div>
              </div>
            </label>
          );
        })}
      </div>
      <FormErrorMessage />
    </FormField>
  );
}
